// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.uppercase[data-v-46f6394e] {\n  text-transform: uppercase;\n}\ninput.uppercase[data-v-46f6394e]::-webkit-input-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-46f6394e]::-moz-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-46f6394e]:-moz-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-46f6394e]:-ms-input-placeholder {\n  text-transform: none;\n}", ""]);
// Exports
module.exports = exports;
